import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import SettingsList from "views/admin/setting/components/SettingsList";

const Settings = () => {

  return (
    <Flex direction="column" mt={"200px"} alignItems={"center"}>
      <Box width="95%">
        <SettingsList />
      </Box>
    </Flex>
  );
};

export default Settings;
